// @flow
import React, { useContext } from 'react';
import classnames from 'classnames';
import { get } from 'lodash';

import { PriceRemoteContext } from 'Components/widgets/price-remote/PriceRemoteContext';
import { PriceRemoteForm } from 'Components/widgets/price-remote/price-remote-form/PriceRemoteForm.jsx';
import { PriceRemoteTicket } from 'Components/widgets/price-remote/price-remote-ticket/PriceRemoteTicket.jsx';
import ResponsiveContext from 'Components/utils/responsive/responsiveContext';
import { isExclusiveCollection } from 'Components/utils/product/product.utils';
import { t } from 'Src/i18n';

export type Props = {
  product: Resort,
  isSticky: boolean,
  bookingCriteria: BookingCriteria,
  classNames: string,
  style?: CSSRuleList,
  urgentisationRate: number,
};

export const PriceRemoteContent = (props: Props) => {
  const { isDesktop } = useContext(ResponsiveContext);
  const [{ isCompact }] = useContext(PriceRemoteContext);
  const { product, isSticky, bookingCriteria, classNames, style = {}, urgentisationRate } = props;

  const isCompactAndIsDesktop = isCompact && isDesktop;
  const isNotCompactAndIsDesktop = !isCompact && isDesktop;
  const isStickyAndIsMobile = isSticky && !isDesktop;
  const isStickyAndIsDesktop = isSticky && isDesktop;
  const isStickyAndIsNotCompact = isSticky && !isCompact;
  const isLongResortTitle = product.name && product.name.length > 45 && isDesktop;
  const isExclusiveCollectionResort = isExclusiveCollection(product.type, product.comfort);

  let departureCities = [...(bookingCriteria.departureCities || [])];
  if (departureCities.length > 0) {
    const departureCityPlaceholder = {
      value: '',
      label: t('faceting.transport.selectPlaceholder'),
    };
    departureCities = [departureCityPlaceholder, ...departureCities];
  }

  return (
    <div className={classNames} style={style}>
      <PriceRemoteTicket
        product={product}
        className={classnames({
          'mb-2 lg:mb-3': isStickyAndIsNotCompact || !isSticky,
          'mb-0': isStickyAndIsMobile,
          'w-full': isNotCompactAndIsDesktop || !isDesktop,
        })}
        isExclusiveCollection={isExclusiveCollectionResort}
      />
      <PriceRemoteForm
        className={classnames({
          'w-full fadeIn': isNotCompactAndIsDesktop || !isDesktop,
          'flex items-center': isCompactAndIsDesktop,
          'm-auto': isLongResortTitle,
        })}
        durationOptions={get(bookingCriteria, 'durations', [])}
        departureCities={departureCities}
        initialTransport={get(bookingCriteria, 'initialTransport')}
        isStickyAndIsDesktop={isStickyAndIsDesktop}
        productId={product.id}
        urgentisationRate={urgentisationRate}
      />
    </div>
  );
};
